import { useAnalytics } from '../../../hooks/useAnalytics';

/**
 * Analytics provider component that tracks page views.
 * Must be placed inside BrowserRouter.
 */
export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  useAnalytics();
  return <>{children}</>;
}

export default AnalyticsProvider;
